import { messaging } from './messaging.js';
import { COMPANY } from './config.js';
import { readJson } from './storage.js';
const KEY = 'vendeySvelteVoice:' + COMPANY;
export async function activateVoice(token, key) {
  const auth = await messaging('/auth/exchange', { method: 'POST', headers: { Authorization: 'Bearer ' + token }, body: '{}' });
  const accessToken = auth.accessToken || auth.access_token || auth.token;
  if (!accessToken) throw new Error('No se recibió un token de acceso.');
  const activation = await messaging('/assistant/realtime/activate', { method: 'POST', headers: { Authorization: 'Bearer ' + accessToken }, body: JSON.stringify({ activation_key: key }) });
  const activationToken = activation.activation_token || activation.activationToken;
  if (!activationToken) throw new Error('No se confirmó la activación.');
  localStorage.setItem(KEY, JSON.stringify({ accessToken, activationToken }));
}
export async function startVoice(onTranscript, onState) {
  const auth = readJson(KEY);
  if (!auth) throw new Error('Activa el asistente con el token del portal y la clave VPRO.');
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  const peer = new RTCPeerConnection();
  const stop = () => { stream.getTracks().forEach(track => track.stop()); peer.close(); };
  try {
    stream.getTracks().forEach(track => peer.addTrack(track, stream));
    const channel = peer.createDataChannel('oai-events');
    channel.onmessage = event => {
      let data; try { data = JSON.parse(event.data); } catch { return; }
      if (data.type === 'session.created') channel.send(JSON.stringify({ type: 'session.update', session: {
        type: 'realtime', audio: { input: { transcription: { model: 'gpt-4o-transcribe', language: 'es' }, turn_detection: { type: 'server_vad' } } },
        instructions: 'Eres el asistente de Vendey Pro. Solo transcribe solicitudes de productos. Las propuestas se resuelven localmente y requieren confirmación visual. Nunca emitas ventas.'
      } }));
      if (data.type === 'conversation.item.input_audio_transcription.completed') onTranscript(data.transcript);
      if (data.type === 'error') onState(data.error?.message || 'Error del asistente.');
    };
    channel.onopen = () => onState('Escuchando. Di, por ejemplo: agrega dos panes.');
    const offer = await peer.createOffer(); await peer.setLocalDescription(offer);
    const response = await fetch('https://cenfelec.com/api/vendey-pro/assistant/realtime/session', {
      method: 'POST', body: offer.sdp, headers: { 'Content-Type': 'application/sdp', Authorization: 'Bearer ' + auth.accessToken, 'X-Vendey-Assistant-Activation': auth.activationToken }
    });
    if (!response.ok) throw new Error(`No se pudo conectar el asistente (${response.status}). Actívalo nuevamente si venció el acceso.`);
    await peer.setRemoteDescription({ type: 'answer', sdp: await response.text() });
    return stop;
  } catch (error) { stop(); throw error; }
}
